
<template>
  <!--用户反馈-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="feedback_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false">

      <template slot="opt_h" slot-scope="{row}">
        <p class="over-text" @click="showDetail(row.msg_content)">{{row.msg_content}}</p>
      </template>

      <template slot="opt_t" slot-scope="{row}">
        <a-button type="link" v-if="row.status_str==='已回复'" href="#" @click="showInfo(row)">{{row.status_str}}</a-button>
        <span v-else>{{row.status_str}}</span>
      </template>
    </x-tabula>

    <!--已回复的弹窗-->
    <a-modal
      :visible="visible"
      @ok="confirm"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      centered
      v-bind="modalConfig"
      :width="900"
    >
      <a-form :form="form">
        <a-row>
          <a-col
            v-for="(item, index) of answerList"
            :key="index"
            :span="item.span">
              <a-form-item
                v-if="item.show && item.label!=='回复'"
                v-bind="item.layout"
                :label="item.label">
                <span :style="{maxWidth: '700px'}" class="ant-form-text">{{item.value}}</span>
              </a-form-item>
              <a-form-item
                v-if="item.show && item.label==='回复'"
                v-bind="item.layout"
                :label="item.label">
                <a-textarea
                  v-decorator="['msg_content', decoratorOptions.msg_content]"
                  rows="4"
                  placeholder="请输入回复内容"></a-textarea>
              </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>

    <!--回复内容详情的弹窗-->
    <a-modal
      title="反馈详情"
      :visible="feedBackVisible"
      @cancel="feedBackVisible=false"
      :footer="null"
      :maskClosable="true"
      :keyboard="true"
      destroyOnClose
      centered
      :width="900"
    >
      <div>{{feedBackContent}}</div>
    </a-modal>
  </div>
</template>

<script>
import mixin from '../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'feedBack',
  data () {
    let layout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 9 }
    };
    let longLayout = { labelCol: { span: 4 }, wrapperCol: { span: 17 } };
    return {
      feedBackContent: '',
      feedBackVisible: false,
      modalConfig: {},
      visible: false,
      btnLoading: { loading: false },
      decoratorOptions: {
        msg_content: {
          validateTrigger: 'blur',
          rules: [{required: true, message: '请输入回复内容'}]
        }
      },
      searchList: [
        { props: ['keywords'], placeholder: '昵称、手机号', inputType: 'input' },
        { props: ['community_id'], placeholder: '小区', options: [], inputType: 'select' },
        { props: ['app_id'], placeholder: '应用', options: [], inputType: 'select' },
        { props: ['msg_status'], placeholder: '回复状态', options: this.$store.state.feedBackStatusSelect, inputType: 'select' },
        { props: ['create_time'], placeholder: ['反馈时间', '反馈时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [],
      rowOptList: [
        { text: '回复', handle: (row) => this.answer(row), key: 'feedback' },
        { text: '删除', handle: (row) => this.$children[0].showDeleteConfirm(row), key: 'delete' }
      ],
      columns: [
        { title: 'ID', dataIndex: 'feedback_id', align: 'left', width: '' },
        { title: '昵称', dataIndex: 'user_name', align: 'left', width: '' },
        { title: '账号', dataIndex: 'mobile_phone', align: 'left', width: '' },
        { title: '小区', dataIndex: 'community_name', align: 'left', width: '' },
        { title: '应用', dataIndex: 'app_desc', align: 'left', width: '' },
        { title: '反馈内容', dataIndex: 'msg_content', align: 'left', width: '', scopedSlots: {customRender: 'action_h'} },
        { title: '反馈时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '状态', dataIndex: 'status_str', align: 'left', width: '', scopedSlots: {customRender: 'action_t'} },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      answerList: [
        { key: 'mobile_phone', label: '账号', value: '', span: 12, layout: layout, show: true },
        { key: 'user_name', label: '昵称', value: '', span: 12, layout: layout, show: true },
        { key: 'app_desc', label: '应用', value: '', span: 12, layout: layout, show: true },
        { key: 'community_name', label: '小区', value: '', span: 12, layout: layout, show: true },
        { key: 'create_time', label: '反馈时间', value: '', span: 24, layout: longLayout, show: true },
        { key: 'msg_content', label: '反馈内容', value: '', span: 24, layout: longLayout, show: true },
        { key: 'msg_content', label: '回复', value: '', span: 24, layout: longLayout, show: true }, // 回复部分
        { key: 'answer_content', label: '回复内容', value: '', span: 24, layout: longLayout, show: true }, // 查看部分
        { key: 'answer_name', label: '回复人', value: '', span: 12, layout: layout, show: true }, // 查看部分
        { key: 'answer_time', label: '回复时间', value: '', span: 12, layout: layout, show: true } // 查看部分
      ],
      dataSource: [],
      searchParams: {
        keywords: '',
        community_id: '',
        app_id: '',
        msg_status: '',
        create_time: ''
      },
      listApi: {
        url: '/feedback',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {},
      deleteParam: {
        url: '/feedback',
        param: {pk_key: 'feedback_id', pk_val: ''},
        title: '用户反馈',
        key: 'user_name'
      }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.communitySelect(1, 'searchList', 1);
      this.marketingManageSelect([{ index: 2, key: 'apps_list' }]);
    },
    /* 查看回复内容 */
    showDetail (content) {
      this.feedBackContent = content;
      this.feedBackVisible = true;
    },
    /* 查看信息 */
    showInfo (row) {
      this.modalConfig = {
        title: '反馈详情',
        footer: null,
        maskClosable: true,
        keyboard: true
      };
      this.answerList.forEach((el) => {
        el.show = true;
      });
      this.loopSetVal(row, ['回复']);
      this.visible = true;
    },
    /* 回复 */
    answer (row) { // 多了回复内容、回复人
      this.modalConfig = {
        title: '回复',
        maskClosable: false,
        keyboard: false
      };
      this.answerList.forEach((el) => {
        el.show = true;
      });
      this.feedBackId = row.feedback_id;
      this.loopSetVal(row, ['回复内容', '回复人', '回复时间']); // 需隐藏的数组
      this.visible = true;
    },
    loopSetVal (row, modelArr) {
      for (let item in row) {
        this.answerList.forEach((el) => {
          if (item === el.key) {
            el.value = row[item];
          }
        });
      }
      this.answerList.forEach((el) => {
        modelArr.forEach((item) => {
          if (item === el.label) {
            el.show = false;
          }
        });
      });
    },
    /* 点击确定弹窗 */
    confirm () {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        this.$post({
          url: '/feedback/answer',
          params: {
            feedback_id: this.feedBackId,
            ...values
          },
          btnLoading: this.btnLoading
        }).then((res) => {
          this.$message.success('回复成功！');
          this.visible = false;
          this.$children[0].getTableList();
        });
      });
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/marketing/feedBack.vue